import { BOMItemType } from '../../../constants/bom-item-type.js';
/** Types whose BomItem rows can hold a Part.defaultBomId link. Update alongside setPartDefaultBom's callers. */
export const BOM_ITEM_TYPES_LINKING_DEFAULT_BOM = new Set([BOMItemType.FINISHED_GOOD]);
//# sourceMappingURL=bom-item-types-linking-default-bom.js.map